import React from "react";
import styled, { createGlobalStyle } from "styled-components";

import Grid from "@material-ui/core/Grid";

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${props => props.theme.sidebar.header.background};
  }
`;

const Root = styled.div`
  max-width: 800px;
  max-height: 500px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
  padding-bottom: 5%;
`;

function TermsAndConds({ children}) {
  return (
    <Root >
      <GlobalStyle />
      <Grid container justify="left" alignItems="left">
        <Grid item xs={12}>{children}</Grid>
      </Grid>
    </Root>
  );
}

export default TermsAndConds;
